module.exports = "/images/wechat-qr.jpg?670cddd5a9c2d068ec74526a82826b29";